export default {
    /*Tabs.jsx*/
    message_1_01: "Sélectionner une plage:",
    message_1_02: "Jour",
    message_1_03: "Semaine",
    message_1_04: "Mois",
    message_1_05: "Smartphones",
    message_1_06: "Tablettes",
    message_1_07: "Notebooks",
    /*Analytics.jsx*/
    message_2_01: "Aperçu",
    message_2_02: "Nombre total de visiteurs",
    message_2_03: "Nouveaux utilisateurs",
    message_2_04: "Utilisateurs récurrents",
    message_2_05: "Ces dernières 24 heures",
    message_2_06: "Cette dernière semaine",
    message_2_07: "Ce dernier mois",
    message_2_08: "Système d'exploitation",
    message_2_09: "Download / upload",
    message_2_10: "Smartphones, tablettes, Notebooks",
    message_2_11: "Nouveaux utilisateurs vs visiteurs récurrents",
    message_2_12: "Nombre total de visites",
    message_2_13: "Chargement",
    /*App.jsx*/
    message_3_01: "Réinitialiser",
    message_3_02: "Rapports",
    message_3_03: "Paramètres",
    message_3_04: "FAQ",
    message_3_05: "Langues",
    message_3_06: "Déconnexion",
    /*RegistrationState.jsx*/
    message_4_01: "Réinitialiser",
    message_4_02: "Détails",
    message_4_03: "Paramètres",
    message_4_04: "Branding",
    message_4_05: "Terminé",
    /*DetailsState.jsx*/
    message_5_01: "Introduisez le nom de votre entreprise et le type d’activité",
    message_5_02: "",
    message_5_03: "Dénomination commerciale",
    message_5_04: "Type d'activité",
    message_5_05: "Personnalisez votre service wi-fi ou cliquez sur \"Ignorer\" pour utiliser les paramètres standard. Vous pouvez également adapter ces données plus tard.",
    message_5_06: "Ignorer",
    message_5_07: "Continuer",
    message_5_08: "Introduisez le nom de l'entreprise",
    message_5_09: "Le nom de votre entreprise ne doit pas dépasser {ruleValue} caractères",
    message_5_10: "Sélectionnez votre type d'activité.",
    message_5_11: "Café",
    message_5_12: "Restaurant",
    message_5_13: "Librairie",
    message_5_14: "Boutique",
    message_5_15: "Magasin de chaussures",
    message_5_16: "Magasin",
    message_5_17: "Bar à café",
    message_5_18: "Supermarché",
    message_5_19: "Centre de jardinage",
    message_5_20: "Garage",
    message_5_21: "Pharmacie",
    message_5_22: "Hôtel",
    message_5_23: "Architecte",
    message_5_24: "Cabinet de médecine générale",
    message_5_25: "Cabinet de dentiste",
    message_5_26: "Coiffure",
    message_5_27: "Salon de beauté",
    message_5_28: "Autre",
    /*SettingsState.jsx*/
    message_6_01: "Gérez vos paramètres wi-fi",
    message_6_02: "Durée du wi-fi gratuit",
    message_6_03: "Déterminez la durée de wi-fi gratuit que vous souhaitez offrir à vos clients",
    message_6_04: "Temps de Wi-Fi gratuit",
    message_6_05: "Pas de limite",
    message_6_06: "15 minutes",
    message_6_07: "30 minutes",
    message_6_08: "1 heure",
    message_6_09: "2 heures",
    message_6_10: "4 heures",
    message_6_11: "Liens vers les médias sociaux",
    message_6_12: "Liens vers les médias sociaux",
    message_6_13: "Retour",
    message_6_14: "Suivant",
    message_6_15: "Sélectionnez l'heure de Wi-Fi gratuit",
    message_6_16: "Format URL invalide pour lien Facebook",
    message_6_17: "Format URL invalide pour lien Twitter",
    message_6_18: "Format URL invalide pour lien Foursquare",
    /*BrandingState.jsx*/
    message_7_01: "Personnalisez l'écran d'accueil pour vos visiteurs",
    message_7_02: "Nom du service wi-fi - Exemple : Bienvenue au Bar Louis",
    message_7_03: "Personnalisez le nom du wi-fi montré à vos clients",
    message_7_04: "Nom du wi-fi",
    message_7_05: "Adresse de votre site web",
    message_7_06: "Ajoutez votre site web",
    message_7_07: "Adresse de votre site web",
    message_7_08: "Arrière-plan",
    message_7_09: "Uploadez votre photo, ou choisissez une photo comme fond d'écran",
    message_7_10: "Pas de fond d'écran",
    message_7_11: "Publicité",
    message_7_12: "Uploadez votre publicité",
    message_7_13: "Charger publicité",
    message_7_14: "Retour",
    message_7_15: "Suivant",
    message_7_16: "Introduisez le nom du wi-fi",
    message_7_17: "Votre nom Wi-Fi ne doit pas dépasser les caractères {ruleValue}",
    message_7_18: "Veuillez entrer l'URL du marchand",
    message_7_19: "Format URL invalide pour le propre URL du client",
    message_7_20: "Aperçu",
    message_7_21: "Uploadez votre photo",
    message_7_22: "Veuillez uploader une photo",
    /*CompleteState.jsx*/
    message_8_01: "Bravo,",
    message_8_02: "vous avez presque terminé",
    message_8_03: "Cliquez sur",
    message_8_04: "PARAMÈTRES",
    message_8_05: "Sauvegarder",
    message_8_06: "pour appliquer les changements à votre portail.",
    message_8_07: "pour les modifier plus tard.",
    message_8_08: "Sauvegarder",
    message_8_09: "Vous pouvez toujours revenir à vos",
    message_8_10: "vous avez terminé",
    message_8_11: "Maintenant, vous pouvez utiliser votre portail par défaut.",
    message_8_12: "Vos modifications ont été enregistrées",
    /*SaveConfirmation.jsx*/
    message_9_01: "En cliquant sur",
    message_9_02: "Continuer",
    message_9_03: "vous choisissez de ne pas tenir compte du modèle par défaut de Proximus et d'appliquer les paramètres que vous avez défini dans ce portail.",
    message_9_04: "Annuler",
    message_9_05: "Vos changements ont été sauvegardés et appliqués au portail.",
    message_9_06: "OK",
    message_9_07: "Un erreur s'est produite. Essayez de vous déconnecter/connecter et répétez ces actions ou contactez Proximus",
    message_9_08: "OK",
    /*RedirectToManagementConsoleConfirmation.jsx*/
    message_10_01: "Vous allez quitter l'assistant CBU Portal Set-up. En cliquant",
    message_10_02: "Enregistrer et continuer",
    message_10_03: "vous choisissez de remplacer le modèle par défaut et d'appliquer vos propres paramètres choisis à ce portail. En cliquant sur",
    message_10_04: "Annuler",
    message_10_05: "vous choisissez de réinitialiser tous les paramètres par défaut.",
    message_10_06: "Quelque chose ne va pas. Essayez d'échouer / connectez-vous et répétez vos actions ou contactez votre fournisseur",
    message_10_07: "OK",
    /*ConfirmReset.jsx*/
    message_11_01: "En cliquant sur",
    message_11_02: "Continuer",
    message_11_03: "vous choisissez de supprimer vos paramètres personnalisés et le portail affichera à nouveau les paramètres d'origine.",
    message_11_04: "Annuler",
    /*Splash.jsx*/
    message_12_01: "Bienvenue sur notre accès wi-fi gratuit!",
    message_12_02: "",
    message_12_03: "Se connecter",
    message_12_04: "Créez votre compte gratuit. Veuillez indiquer votre numéro de GSM",
    message_12_05: "Numéro de GSM",
    message_12_06: "J'accepte les",
    message_12_07: "conditions et les règles relatives",
    message_12_08: "à la",
    message_12_09: "protection de la vie privée",
    message_12_10: "S'inscrire",
    message_12_11: "J’ai déjà un code PIN",
    message_12_12: "Powered by",
    /*Verification.jsx*/
    message_13_01: "Activer votre compte",
    message_13_02: "Introduisez le code PIN que vous avez reçu au:",
    message_13_04: "PIN",
    message_13_05: "Se connecter",
    message_13_06: "Modifier le numéro",
    message_13_07: "Nouveau code PIN",
    message_13_08: "Powered by",
    /*Loading.jsx*/
    message_14_01: "Connexion en cours, veuillez patienter...",
    /*Interstitial.jsx*/
    message_15_01: "Cliquez sur ce message",
    message_15_02: "ou patientez 5 secondes...",
    /*Success.jsx*/
    message_16_01: "Bienvenue dans notre accès WiFi gratuit!",
    message_16_02: "Pour vous assurer que votre temps d'attente passe plus rapidement, nous nous assurons que vous pouvez profiter du WiFi gratuit dans notre centre de Proximus.",
    message_16_03: "Bravo, vous êtes connecté",
    message_16_04: "Profitez dès maintenant de votre connexion internet gratuite!",
    message_16_05: "Powered by",
    /*PreviewWindow.jsx*/
    message_17_01: "Trajet personnalisé de l'utilisateur du wi-fi",
    message_17_02: "Enregistrement",
    message_17_03: "Vérifier",
    message_17_04: "Chargement en cours…",
    message_17_05: "Publicité",
    message_17_06: "Réussi",
    /*OperatingSystem.jsx*/
    message_18_01: "Autre",
    /*TotalVisits.jsx*/
    message_19_01: "Nombre total de visites",
    /*DataDownloadVsUpload.jsx*/
    message_20_01: "Download",
    message_20_02: "Upload",
    /*NewVsReturning.jsx*/
    message_21_01: "Nouveaux utilisateurs",
    message_21_02: "Utilisateurs récurrents",
    /*ImageUploadContainer.jsx*/
    message_22_01: "Supprimer l'annonce",
    message_22_02: "Choisir le fichier",
    /*BackgroundImageUploadContainer.jsx*/
    message_23_01: "Supprimer le fond d'écran",
    message_23_02: "Choisissez un fichier",
    message_23_03: "Les photos seront automatiquement ajustées par le portal",
    message_23_04: "Utilisez une photo avec une orientation horizontale",
    message_23_05: "N'utilisez pas une photo avec une faible résolution",
    message_23_06: "Les dimensions recommandées pour la photo sont 1280 x 720",
    message_23_07: "Le nom du fichier ne peut excéder 45 caractères"
};


// WEBPACK FOOTER //
// ./src/locales/fr.js